export default __webpack_public_path__ + "static/media/jewelry.63c92739.svg";